module.exports = __webpack_public_path__ + "static/media/circle_04.cc98b99a.svg";